import { withMeetingBasedMarketTemplateModelState } from '@swf/sports/models/market-templates/meetingBased';

import type { SportsNextRacesState } from './types';

export const defaultState = withMeetingBasedMarketTemplateModelState<SportsNextRacesState>({
  isLoading: false,
  hasPreloaded: false,
  templates: [],
  ukIeTemplates: [],
  selectedTab: ''
});
